import React from "react";
import { getSiteBrand } from "@/lib/siteHosts";

const QuietHero = ({ onOpenModal }) => (
  <section className="cursor-section settrhq-hero" data-testid="quiet-hero">
    <div className="cursor-container">
      <div className="cursor-hero-message" data-testid="quiet-headline">
        <p className="settrhq-hero-badge">🛠️ Built by roofers, for roofers</p>
        <h1 className="cursor-hero-h1">
          <span>Stop paying for </span>
          <span className="settrhq-hero-pain">shitty leads.</span>{" "}
          <span className="settrhq-hero-gain">Lock in the jobs</span>{" "}
          <span>already visiting your website.</span>
        </h1>
        <p className="cursor-hero-subhead" data-testid="quiet-subheadline">
          Our digital assistant qualifies and books{" "}
          <strong className="settrhq-hero-emphasis">roof inspection quotes</strong> straight into your
          calendar in{" "}
          <strong className="settrhq-hero-speed">
            <span className="settrhq-hero-mono">26 seconds</span> flat
          </strong>
          {". "}So you never lose a job while you’re{" "}
          <strong className="settrhq-hero-pain">up on a roof</strong> or{" "}
          <strong className="settrhq-hero-pain">off tools</strong> for the day.
        </p>
      </div>

      <div className="settrhq-hero-cta">
        <button
          type="button"
          className="settrhq-hero-button"
          onClick={onOpenModal}
          data-testid="quiet-hero-cta"
        >
          Plug {getSiteBrand().name} in (Free) →
        </button>
        <p className="settrhq-hero-micro" data-testid="quiet-hero-cta-disclosure">
          14-day free trial · No credit card · Cancel anytime
        </p>
      </div>
    </div>
  </section>
);

export default QuietHero;
